// @flow

import * as React from 'react';
import styled from 'styled-components';
import ReactModal from 'react-modal';
import { translate } from "react-i18next";
import DefaultButton from './../../../components/DefaultButton';
import GhostButton from './../../../components/GhostButton';

type State = {
    visible: boolean,
    confirmCallback: () => void,
    cancelCallback: () => void,
    title: string,
    content: any,
    confirmBtnVisible: boolean,
    cancelBtnText: string,
    confirmBtnText: string,
    closeOnConfirm: boolean,
    type: string,
}
type Props = {
    t: (s: string) => string
}

const ButtonWrapper = styled.div`
    display: flex;
    justify-content: space-between;
`;

class Modal extends React.Component<Props, State> {
    close = () => {
        this.setState({ visible: false })
    }

    show = () => {
        this.setState({ visible: true })
    }

    customize(config: Object) {
        const { t } = this.props;
        const emptyFunction = () => { };
        this.setState({
            title: config.title || '',
            confirmCallback: config.confirmCallback || emptyFunction,
            cancelCallback: config.cancelCallback || emptyFunction,
            content: config.content || '',
            confirmBtnVisible: config.confirmBtnVisible,
            cancelBtnVisible: config.cancelBtnVisible,
            cancelBtnText: config.cancelBtnText || t('Cancel'),
            confirmBtnText: config.confirmBtnText || 'Ok',
            closeOnConfirm: config.closeOnConfirm,
            type: config.type || '',            
        })        
    }

    constructor(props) {
        super();
        const { t } = props;
        this.state = {
            visible: false,
            cancelVisible: true,
            confirmCallback: () => { },
            cancelCallback: () => { },
            title: '',
            content: '',
            confirmBtnVisible: false,
            cancelBtnVisible: true,
            cancelBtnText: t('Cancel'),
            confirmBtnText: 'Ok',
            closeOnConfirm: true,
        }
    }

    render() {
        ReactModal.setAppElement('#root');
        return (
            <div>
                <ReactModal
                    style={{
                        overlay: {
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            backgroundColor: 'rgba(150, 150, 150, 0.85)',
                        },
                        content: {
                            position: 'static',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flexDirection: 'column',
                            maxWidth: '655px',
                        }
                    }}
                    isOpen={this.state.visible}
                    contentLabel={this.state.title}
                >
                    {this.state.content}
                    <ButtonWrapper>
                        <GhostButton
                            style={{
                                minWidth: '60px',
                                margin: '5px',
                                height: '25px',
                                display: this.state.cancelBtnVisible ? 'flex' : 'none',
                                alignItems: 'center',
                            }}
                            title={this.state.cancelBtnText}
                            onClick={() => {
                                const { cancelCallback } = this.state;
                                if (typeof cancelCallback === 'function')
                                    cancelCallback();
                                this.setState({ visible: false })
                            }}>
                            {this.state.cancelBtnText}
                        </GhostButton> 
                        <DefaultButton
                            style={{
                                minWidth: '60px',
                                margin: '5px',
                                height: '26px',
                                display: this.state.confirmBtnVisible ? 'flex' : 'none',
                            }}
                            type={this.state.type}
                            title={this.state.confirmBtnText}
                            onClick={() => {
                                const { confirmCallback } = this.state;
                                if (typeof confirmCallback === 'function')
                                    confirmCallback();
                                if (this.state.closeOnConfirm)
                                    this.setState({ visible: false })
                            }}>
                            {this.state.confirmBtnText}
                        </DefaultButton>
                    </ButtonWrapper>
                </ReactModal>
            </div >
        )
    }
}

export default translate("translations", { withRef: true })(Modal);


// WEBPACK FOOTER //
// ./src/containers/content/modal/Modal.jsx